import { useEffect } from 'react';
import { toast } from 'sonner';
import { MainPage } from '@/presentation/pages/MainPage';
import { Toaster } from '@/presentation/components/ui/sonner';
import { indexedDBAdapter } from '@/infrastructure/storage/IndexedDBAdapter';
import { logger } from '@/lib/logger';
import { useUpdateNotifier } from '@/presentation/hooks/useUpdateNotifier';

function App() {
  useUpdateNotifier();

  useEffect(() => {
    indexedDBAdapter.init().catch((error) => {
      logger.error('IndexedDBの初期化に失敗しました', error as Error, {
        context: 'App initialization',
      });
      toast.error('ストレージの初期化に失敗しました', {
        description: 'プライベートモードを無効にするか、ブラウザの設定を確認してください。',
        duration: 8000,
      });
    });
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <MainPage />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
